// eslint-disable-next-line @nx/enforce-module-boundaries
import { EmitTransportToken } from '@mode/reports/sandbox/util-transport';
import { Inject, Injectable } from '@angular/core';
import { ErrorReporter } from '@mode/shared/contract-common';
import { createEffect } from '@ngrx/effects';
import { filter, tap } from 'rxjs';
import { EmitMessages, EmitTransport } from '@mode/reports/sandbox/contract';

@Injectable()
export class ReportRpcErrorEffects {
  notifyBugsnag$ = createEffect(
    () =>
      this.emitter.getMessageStream(this.window).pipe(
        filter((f) => f.type === EmitMessages.MessageTypes.Error),
        tap((message: EmitMessages.Error) => this.errorReporter.notify(message.errorEvent))
      ),
    { dispatch: false }
  );

  constructor(
    private window: Window,
    @Inject(EmitTransportToken) private emitter: EmitTransport,
    private errorReporter: ErrorReporter
  ) {}
}
